import { put, call, takeLatest, takeEvery, fork, all, select } from "redux-saga/effects";
import { getProvidersList } from "../api/directSchedulingApi";
import * as types from "../constants/actionTypes";
import { log, logAPI } from "../api/andyliticsApi";

export default function* directSchedulingSaga() {
    yield takeLatest(types.DIRECT_SCHEDULING_PROVIDER_LIST, handleProviderList);
    yield takeLatest(types.SWITCH_USER_SAGA, handleProviderList);
}

export function* handleProviderList(payload) {
    const start = new Date();
    try {
        //debugger;
        let providers = [];
        if (window.serverData.data.enableDirectScheduling === true) {
            let searchModel = {};
            const domain = yield select((state) => state.domain);
            if (payload && payload.searchModel) {
                if (!payload.searchModel.proxyPatientId) {
                    payload.searchModel.proxyPatientId = domain.cu && domain.cu.ei ? domain.cu.ei : null;
                }
                searchModel = payload.searchModel;
            } else {
                //Handle for proxies or if search model not found.
                const currentUser = payload && payload.user ? payload.user : null;
                const externalId = currentUser && currentUser.externalId ? currentUser.externalId : domain.cu && domain.cu.ei ? domain.cu.ei : null;
                searchModel = { loginId: domain.un, proxyPatientId: externalId };
            }

            if (searchModel && searchModel.proxyPatientId) {
                providers = yield call(getProvidersList, searchModel, payload.token ? payload.token : domain.t);
            } else {
                logAPI("MBHWeb.Saga.DirectScheduling.ProviderList.NotLoaded", start, null);
            }
        }

        yield all([
            put({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS, providers })
        ]);

        if (window.serverData.data.enableDirectScheduling === true) {
            logAPI("MBHWeb.Saga.DirectScheduling.ProviderList", start, null);
        }
    }
    catch (error) {
        yield all([
            put({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE, error })
        ]);
        let errorRspMsg = null;
        let errorStatus = null;
        if (error && error.status) {
            try {
                errorStatus = error.status;
                errorRspMsg = yield call(parseRspMsg, error);
            } catch (err) { };
        }
        logAPI("MBHWeb.Saga.DirectScheduling.ProviderList.Failure", start, null, { status: errorStatus, errorRsp: errorRspMsg });

    }
}

function parseRspMsg(rspMsg) {
    try {
        return rspMsg.json().then(data => {
            return data;
        });
    }
    catch (e) {
        return {};
    }
}
